exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__toggled-root___96dPv{height:10rem;border-radius:0 0 5px 5px;display:flex;flex-direction:column;justify-content:space-evenly;align-items:center}", ""]);

// exports
exports.locals = {
	"toggled-root": "styles__toggled-root___96dPv"
};